var _rect, _path, _path2, _path3, _path4, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWhatsapp({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "url(#paint0_linear)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.458 72.484L36.4684 73.083C40.7141 75.6026 45.5817 76.9351 50.5456 76.9378H50.5564C65.8008 76.9378 78.208 64.5335 78.2138 49.2881C78.2162 41.8995 75.3422 34.9529 70.1204 29.7263C64.8982 24.5006 57.9549 21.6207 50.5663 21.6176C35.3103 21.6176 22.9031 34.02 22.8974 49.2654C22.8953 54.4897 24.3568 59.5777 27.1258 63.9795L27.7839 65.0258L24.9892 75.2287L35.458 72.484ZM17.0002 83.1321L21.721 65.8944C18.8092 60.8494 17.2774 55.1265 17.2798 49.2639C17.2869 30.9222 32.2134 16 50.5571 16C59.4582 16.0038 67.813 19.4681 74.0957 25.756C80.3777 32.0438 83.8363 40.4019 83.8334 49.2907C83.8256 67.6315 68.8959 82.5565 50.5571 82.5565C50.5557 82.5565 50.5577 82.5565 50.5571 82.5565H50.5429C44.9738 82.5546 39.5016 81.1577 34.6413 78.5068L17.0002 83.1321Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4267 49.2812C18.4247 54.9403 19.9034 60.4653 22.7151 65.3361L18.1573 81.9772L35.1869 77.5118C39.8789 80.0687 45.1615 81.4184 50.5378 81.4202H50.5517C68.2565 81.4202 82.6674 67.0131 82.6751 49.3064C82.6784 40.7253 79.34 32.6576 73.2745 26.5869C67.21 20.517 59.1446 17.1724 50.5502 17.1684C32.8445 17.1684 18.4336 31.5736 18.4259 49.2812L18.4267 49.2812ZM50.5512 81.42H50.5515H50.5512C50.5509 81.42 50.5505 81.42 50.5512 81.42Z",
    fill: "url(#paint1_linear)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2795 49.2716C17.2775 55.1341 18.8093 60.8577 21.7212 65.9021L17 83.1388L34.6405 78.5135C39.5011 81.164 44.973 82.5609 50.542 82.5632H50.5563C68.8951 82.5632 83.8249 67.6381 83.8326 49.2974C83.8357 40.4081 80.377 32.0501 74.0949 25.7626C67.8118 19.4751 59.4576 16.0105 50.5563 16.0067C32.2136 16.0067 17.2866 30.9288 17.279 49.2705L17.2795 49.2716ZM27.784 65.033L27.1255 63.9871C24.3565 59.5848 22.8951 54.4968 22.8971 49.273C22.9032 34.0286 35.3101 21.6252 50.566 21.6252C57.9539 21.6281 64.8974 24.5083 70.1202 29.7339C75.3424 34.9598 78.2159 41.907 78.2139 49.2947C78.2072 64.5401 65.8 76.9444 50.5556 76.9444H50.5448C45.581 76.9415 40.713 75.6091 36.4676 73.0899L35.4572 72.491L24.9886 75.2356L27.784 65.033ZM50.5563 82.5632H50.5566H50.5563C50.5559 82.5632 50.5556 82.5632 50.5563 82.5632Z",
    fill: "url(#paint2_linear)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.2396 35.3632C41.6167 33.9785 40.9612 33.9508 40.3687 33.9265C39.8838 33.9058 39.3292 33.9072 38.7753 33.9072C38.2207 33.9072 37.3199 34.1153 36.5582 34.9473C35.7958 35.7794 33.6478 37.7908 33.6478 41.8814C33.6478 45.9725 36.6277 49.9254 37.0428 50.4807C37.4587 51.035 42.795 59.6983 51.2456 63.0308C58.2694 65.8005 59.6987 65.2496 61.2231 65.1108C62.7476 64.9724 66.1425 63.1001 66.8352 61.1585C67.5282 59.2172 67.5282 57.5531 67.3204 57.2056C67.1126 56.8591 66.558 56.651 65.7266 56.2355C64.8949 55.8196 60.8072 53.808 60.0452 53.5305C59.2828 53.2533 58.7285 53.1149 58.1739 53.9473C57.6196 54.7787 56.0272 56.651 55.542 57.2056C55.0571 57.7613 54.5719 57.8306 53.7404 57.4148C52.9087 56.9975 50.2307 56.1204 47.054 53.2882C44.5821 51.0844 42.9135 48.3627 42.4283 47.5303C41.9434 46.6989 42.3765 46.2485 42.7934 45.8339C43.167 45.4614 43.6251 44.8631 44.041 44.3779C44.4559 43.8923 44.5943 43.5458 44.8714 42.9912C45.1489 42.4362 45.0101 41.9506 44.8024 41.5347C44.5943 41.1188 42.9785 37.0071 42.2391 35.363",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 50.0005,
    y1: 99.9896,
    x2: 50.0005,
    y2: -0.0105083,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#20B038"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60D66A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60D66A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 50.4166,
    y1: 81.9705,
    x2: 50.4166,
    y2: 17.1616,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#20B038"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60D66A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60D66A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 50.4168,
    y1: 83.1407,
    x2: 50.4168,
    y2: 16.0087,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsapp);
export default __webpack_public_path__ + "static/media/Whatsapp.78f40f5b0df862179e3b7f2d98e3f4a2.svg";
export { ForwardRef as ReactComponent };